import { when } from 'mobx';
import * as React from 'react';

import { inject, observer } from 'mobx-react';
import { ApplicationStore } from '../_stores/ApplicationStore';

import { FRESHDESK } from '../Config/UIConstants';

import { CommonTextInput } from './CommonTextInput';
import { InformationIcon } from './InformationIcon';

import { largeShadow } from '../styles/styleObjects';

import { colors } from '../styles/colors';

interface IProps {
    store?: ApplicationStore;
    value: string;
    updateValue(text: string): void;
}

interface IState {
    storyTitleDefault: string;
}

@inject('store')
@observer
export class StoryTitleField extends React.Component<IProps> {

    public state: IState = {
        storyTitleDefault: '',
    };

    public componentDidMount(): void {
        this.setDefaultStoryTitle();
    }

    private updateTitleState = (text: string) => {
        this.props.updateValue(text);
    }

    private async setDefaultStoryTitle(): Promise<void> {
        let currentTimestamp = new Date();
        let userInitials = '';
        await when(() => !!this.props.store && !!this.props.store.userStore);
        try {
            userInitials = this.props.store!.userStore.getUserInitials();
        } catch {
            console.log('unable to get user initials');
        }
        let placeholder = userInitials + ' ' + currentTimestamp.toLocaleString();
        this.setState({storyTitleDefault: placeholder});
        this.updateTitleState(placeholder);
    }

    private insertDefaultTitle(): void {
        if (this.props.value === '') {
            this.updateTitleState(this.state.storyTitleDefault);
        }
    }

    private clearDefaultTitle(): void {
        if (this.props.value === this.state.storyTitleDefault) {
            this.updateTitleState('');
        }
    }

    public render() {
        const { value } = this.props;
        const { storyTitleDefault } = this.state;

        return (
            <div style={styles.storyNameInputWrap}>
                <CommonTextInput
                    header="Album Title"
                    value={value}
                    containerStyle={styles.inputContainer}
                    maxLength={70}
                    onChangeText={this.updateTitleState}
                    textStyle={value === storyTitleDefault ? { color: colors.MEDIUM_GRAY_TEXT } : {}}
                    onFocus={() => {this.clearDefaultTitle(); }}
                    onBlur={() => {this.insertDefaultTitle(); }}
                />
                <InformationIcon
                    link={FRESHDESK.STORY_ALBUM_TITLE}
                    style={styles.storyNameInfoIcon}/>
            </div>
        );
    }
}
const styles = {
    inputContainer: {
        width: '100%',
        height: 85,
        backgroundColor: 'white',
        boxShadow: largeShadow,
    },
    storyNameInputWrap: {
        position: 'relative',
        marginTop: 20,
        marginBottom: 15,
    } as React.CSSProperties,
    storyNameInfoIcon: {
        height: '2em',
        position: 'absolute',
        top: 0,
        right: '-2.5em'
    } as React.CSSProperties,
};



// WEBPACK FOOTER //
// ./src/SharedComponents/StoryTitleField.tsx